import React from 'react';
import { HOVER_HINT } from 'components/Toolbar/constants';
import BackgroundImage from 'components/Toolbar/Controls/BackgroundImage';
import BorderRadius from 'components/Toolbar/Controls/BorderRadius';
import FillColor from 'components/Toolbar/Controls/FillColor';
import FontSize from 'components/Toolbar/Controls/FontSize';
import Padding from 'components/Toolbar/Controls/Padding';
import Scrollable from 'components/Toolbar/Controls/Scrollable';
import ControlGroup from 'components/Toolbar/Shared/ControlGroup';
import { ProjectsConfig } from 'const';
import BaseToolbar from 'containers/Toolbar/BaseToolbar';
import { intlGet } from 'utils/intlGet';
import { ToolbarProps } from './models';

const Toolbar: React.FunctionComponent<ToolbarProps> = (props) => {
  const {
    styles,
    stylesSetters,
    fontSize,
    layoutId,
    projectType,
    toggleFontSize,
  } = props;
  const { allowBackgroundOpacity, allowBackgroundImage, allowScrollableLayout } = ProjectsConfig[projectType];

  return (
    <BaseToolbar title={intlGet('EditorToolbar.Asset', 'Layout')} layoutId={layoutId}>
      <ControlGroup>
        <FontSize
          fontSize={fontSize}
          toggleFontSize={toggleFontSize}
        />
      </ControlGroup>
      <ControlGroup>
        <Padding
          padding={styles.padding}
          togglePadding={stylesSetters.padding}
        />
        <FillColor
          activeColor={styles.backgroundColor}
          toggleColor={stylesSetters.backgroundColor}
          opacity={styles.backgroundColorOpacity}
          toggleOpacity={allowBackgroundOpacity ? stylesSetters.backgroundColorOpacity : null}
          gradient={styles.backgroundGradient}
          toggleGradient={stylesSetters.backgroundGradient}
        />
        {allowBackgroundImage && <BackgroundImage
          backgroundImage={styles.backgroundImage}
          toggleBackgroundImage={stylesSetters.backgroundImage}
        />}
        <BorderRadius
          borderRadius={styles.borderRadius}
          title={HOVER_HINT.LAYOUT}
          dropdownWarningMessage={intlGet('EditorToolbar.Tooltip', 'WarningMessage')}
          toggleBorderRadius={stylesSetters.borderRadius}
        />
      </ControlGroup>
      {allowScrollableLayout &&
        <ControlGroup>
          <Scrollable
            scrollable={styles.scrollable}
            toggleScrollable={(): void => stylesSetters.scrollable(!styles.scrollable)}
          />
        </ControlGroup>
      }
    </BaseToolbar>
  );
};

export default Toolbar;
